import { useEffect, useState } from 'react'
import type { FC, MutableRefObject } from 'react'
import type { InputProps } from 'antd/es/input'

import { SC_Input } from './styled'


export type T_FrameStyle = 'stroked' | 'framed'
export type T_CustomInputType = 'numeric'

export type T_InputProps = InputProps & {
  label?: string,
  $frameStyle?: T_FrameStyle
  $minWidth?: string
  setFormValue?: (key: string, value: string) => void
  $customType?: T_CustomInputType
  isSearch?: boolean
  $isPhone?: boolean
  $extraSize?: 'veryLarge'
  $isVeryRadiused?: boolean
  $ref?: MutableRefObject<HTMLElement | null>
}

export const InputWrapper: FC<T_InputProps> = ({
  $customType,
  name,
  setFormValue,
  onChange,
  onBlur,
  value,
  $extraSize,
  $isVeryRadiused,
  $ref,
  ...rest
}) => {
  const [ val, setVal ] = useState(value ?? '')

  useEffect(() => {
    setVal(value ?? '')
  }, [ value ])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.currentTarget.value

    if ($customType === 'numeric' && !/^\d*(\.\d*)?$/.test(raw)) return

    setVal(raw)
    onChange?.(e)
    setFormValue?.(name!, String(raw))
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if ($customType === 'numeric') {
      let clean = val
      if (typeof clean === 'string' && clean.endsWith('.')) clean = clean.slice(0, -1)

      if (typeof clean === 'string') {
        clean = clean.replace(/^0+(\d)/, '$1')
      }
      setVal(clean)
      setFormValue?.(name!, String(clean))
    }

    onBlur?.(e)
  }


  return (
    <SC_Input
      name={name}
      $customType={$customType}
      onChange={handleChange}
      onBlur={handleBlur}
      value={val}
      type={$customType === 'numeric' ? 'tel' : rest.type}
      $extraSize={$extraSize}
      $isVeryRadiused={$isVeryRadiused}
      $ref={$ref}
      {...rest}
    />
  )
}
